import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export const Support = () => {
  const [search] = useSearchParams()
  const [ready, setReady] = useState(false)

  useEffect(() => {
    if (search.get('phone_number') && search.get('name') && search.get('email')) {
      setReady(true)
    }
  }, [search])

  return (
    <div>
      {!ready ? (
        <div>
        </div>
      ) : (
        <div dangerouslySetInnerHTML={{
          __html: `
      <script type="text/javascript" src="//hedeffilo.alo-tech.com/chatwidget/alochat.js?widget_key=ddcfe043f377497dee037003d5fde39cd8fab9f61d68ed071a2958e7302ea3daecdca207f1715c14242afc7b76cef3b1b612a36dd83bd7e395541b0bb19d68a422f83e5d8c2f56de3aa7b8fe256b7cd7aa3dedb763c7fc5217ce1aa0b12c4fe8eee2&fullsize=true"></script>
        <script type="text/javascript">

            // Event Listening
            window.addEventListener("message", function (e) {
                var data = JSON.parse(e.data);
                console.log(data);

                // Wait for initiliaze event
                if (data.type === "chat" && data.action === "alotech_initialize") {
                    console.log("*** alotech initialize ***");

                    aloChatIframe = document.querySelector('#AloChatIframe');

                    // Send post message
                    if (aloChatIframe) {
                        aloChatIframe.contentWindow.postMessage(JSON.stringify({
                                action: 'alotech_external_chat_start',
                                formdata: {
                                    phone_number: "${search.get('phone_number')}",
                                    name: "${search.get('name')}",
                                    email: "${search.get('email')}"
                                },

                            }),
                        'https://' + window.AloChat.chat_ws_server);
                    }
                }
            }, false);
            startWidget({
                user_data: {"user_id": "${search.get('user_id')}"}
            });
        </script>
      `
        }} />
      )}
    </div>
  )
}